// src/pages/AGB.tsx
import { Layout } from '@/components/Layout';

export default function AGB() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p className="text-muted-foreground text-sm mb-10">Stand: April 2026</p>

        <div className="space-y-10 text-sm leading-relaxed text-foreground">

          <section>
            <h2 className="font-bold text-lg mb-3">§ 1 Geltungsbereich</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle
              Verträge zwischen Jonas Huber / Salesforge (nachfolgend „Anbieter") und den Nutzern der
              Plattform Salesforge (nachfolgend „Nutzer").
            </p>
            <p className="mt-2">
              (2) Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB,
              d. h. natürliche oder juristische Personen oder rechtsfähige Personengesellschaften,
              die bei Abschluss des Rechtsgeschäfts in Ausübung ihrer gewerblichen oder
              selbständigen beruflichen Tätigkeit handeln. Verbrauchern im Sinne des § 13 BGB
              ist die Nutzung der Plattform ausdrücklich nicht gestattet.
            </p>
            <p className="mt-2">
              (3) Abweichende Bedingungen des Nutzers werden nicht anerkannt, es sei denn, der
              Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 2 Vertragsgegenstand</h2>
            <p>
              (1) Der Anbieter betreibt eine digitale SaaS-Plattform zur Analyse und
              Optimierung von Vertriebsprozessen. Die Plattform ermöglicht Nutzern:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-muted-foreground">
              <li>die kostenlose Durchführung eines strukturierten Online-Audits ihres Vertriebsprozesses,</li>
              <li>den Abruf einer ersten Ergebnisübersicht auf Basis der Eingaben,</li>
              <li>die kostenpflichtige Freischaltung erweiterter, individualisierter Handlungsempfehlungen.</li>
            </ul>
            <p className="mt-2">
              (2) Die Ergebnisse und Empfehlungen werden auf Basis der Nutzereingaben mittels
              automatisierter Systeme und teilweise KI-gestützter Verarbeitung generiert. Sie
              stellen keine individuelle Unternehmensberatung, Rechts- oder Steuerberatung dar.
            </p>
            <p className="mt-2">
              (3) Optionale Beratungs- und Umsetzungsleistungen (z. B. Strategiegespräch,
              Implementierungsbegleitung) sind nicht Bestandteil dieser AGB und werden
              gesondert vereinbart.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 3 Vertragsschluss</h2>
            <p>
              (1) Das kostenlose Audit kann ohne Registrierung genutzt werden. Durch Starten
              des Audits kommt kein kostenpflichtiger Vertrag zustande.
            </p>
            <p className="mt-2">
              (2) Ein kostenpflichtiger Vertrag über die Freischaltung der Handlungsempfehlung
              kommt erst durch erfolgreiche Zahlung des ausgewiesenen Betrags zustande. Mit
              Abschluss der Zahlung über Stripe bestätigt der Nutzer, diese AGB gelesen und
              akzeptiert zu haben.
            </p>
            <p className="mt-2">
              (3) Der Anbieter behält sich vor, Bestellungen ohne Angabe von Gründen abzulehnen,
              insbesondere wenn der Verdacht besteht, dass der Nutzer kein Unternehmer im Sinne
              des § 14 BGB ist.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 4 Preise und Zahlung</h2>
            <p>
              (1) Die Freischaltung der erweiterten Handlungsempfehlung kostet einmalig{' '}
              <strong>149,00 € (netto zzgl. der gesetzlichen Umsatzsteuer)</strong> bzw. den
              jeweils auf der Zahlungsseite ausgewiesenen Betrag.
            </p>
            <p className="mt-2">
              (2) Die Zahlung erfolgt ausschließlich über den Zahlungsdienstleister Stripe, Inc.
              Es werden die von Stripe angebotenen Zahlungsmethoden akzeptiert (z. B. Kreditkarte,
              SEPA-Lastschrift). Die Verarbeitung der Zahlungsdaten erfolgt ausschließlich durch
              Stripe gemäß deren Datenschutzbedingungen.
            </p>
            <p className="mt-2">
              (3) Die Leistung wird unmittelbar nach erfolgreicher Zahlungsbestätigung freigeschaltet.
            </p>
            <p className="mt-2">
              (4) Alle ausgewiesenen Preise verstehen sich als Nettopreise zzgl. der jeweils
              gültigen gesetzlichen Umsatzsteuer.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 5 Leistungsumfang und KI-Hinweis</h2>
            <p>
              (1) Der Anbieter erbringt die Analyse und Handlungsempfehlungen auf Basis der
              vom Nutzer eingegebenen Daten. Die Qualität und Relevanz der Ergebnisse hängt
              maßgeblich von der Vollständigkeit und Richtigkeit der Nutzereingaben ab.
            </p>
            <p className="mt-2">
              (2) Teile der Auswertung werden mithilfe automatisierter und KI-gestützter
              Systeme generiert. Der Nutzer nimmt zur Kenntnis, dass:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-muted-foreground">
              <li>die Ergebnisse allgemeiner Natur sind und keine individuelle betriebswirtschaftliche Beratung ersetzen,</li>
              <li>keine Garantie für bestimmte geschäftliche Ergebnisse, Umsatzsteigerungen oder Kosteneinsparungen übernommen wird,</li>
              <li>die Empfehlungen als Orientierungshilfe zu verstehen sind und vor Umsetzung einer eigenen Prüfung bedürfen.</li>
            </ul>
            <p className="mt-2">
              (3) Der Anbieter ist berechtigt, den Leistungsumfang der Plattform jederzeit
              weiterzuentwickeln, zu ändern oder zu erweitern, sofern dies dem Nutzer zumutbar ist.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 6 Verfügbarkeit der Plattform</h2>
            <p>
              (1) Der Anbieter ist bemüht, die Plattform mit einer Verfügbarkeit von 95 %
              im Jahresmittel bereitzustellen. Hiervon ausgenommen sind Wartungszeiten sowie
              Ausfälle außerhalb des Einflussbereichs des Anbieters (z. B. Infrastruktur
              von Drittanbietern wie Supabase, Stripe oder CDN-Dienste).
            </p>
            <p className="mt-2">
              (2) Auf geplante Wartungen wird der Anbieter, soweit möglich, vorab hinweisen.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 7 Nutzungsrechte</h2>
            <p>
              (1) Mit Zahlung des vereinbarten Entgelts erhält der Nutzer ein einfaches,
              nicht übertragbares Nutzungsrecht an den freigeschalteten Inhalten für interne
              Geschäftszwecke des eigenen Unternehmens.
            </p>
            <p className="mt-2">
              (2) Eine Weitergabe, Vervielfältigung, Veröffentlichung oder kommerzielle
              Verwertung der Ergebnisse gegenüber Dritten ist ohne ausdrückliche schriftliche
              Zustimmung des Anbieters untersagt.
            </p>
            <p className="mt-2">
              (3) Dem Nutzer ist es nicht gestattet, die Plattform oder deren Inhalte zu
              reverse-engineeren, zu scrapen oder für eigene gewerbliche Angebote zu verwenden.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 8 Haftung</h2>
            <p>
              (1) Der Anbieter haftet uneingeschränkt für Schäden, die auf Vorsatz oder grober
              Fahrlässigkeit beruhen, sowie für Schäden aus der Verletzung des Lebens, des Körpers
              oder der Gesundheit.
            </p>
            <p className="mt-2">
              (2) Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten)
              ist die Haftung auf den typischerweise vorhersehbaren Schaden begrenzt, maximal jedoch
              auf den vom Nutzer für die jeweilige Leistung tatsächlich gezahlten Betrag.
            </p>
            <p className="mt-2">
              (3) Die Haftung für mittelbare Schäden, Folgeschäden, entgangenen Gewinn oder
              ausgebliebene Einsparungen ist — soweit rechtlich zulässig — ausgeschlossen.
            </p>
            <p className="mt-2">
              (4) Der Anbieter übernimmt insbesondere keine Haftung dafür, dass die auf Basis
              der Audit-Ergebnisse umgesetzten Maßnahmen zu bestimmten geschäftlichen Erfolgen führen.
            </p>
            <p className="mt-2">
              (5) Für Inhalte verlinkter externer Websites ist der Anbieter nicht verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 9 Ausschluss des Widerrufsrechts</h2>
            <p>
              Da das Angebot ausschließlich an Unternehmer im Sinne des § 14 BGB gerichtet ist,
              besteht kein gesetzliches Widerrufsrecht. Die Leistung wird nach erfolgreicher
              Zahlung unmittelbar erbracht. Eine Rückerstattung nach Freischaltung der Inhalte
              ist ausgeschlossen, es sei denn, der Anbieter hat die Leistung nicht oder nicht
              vertragsgemäß erbracht.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 10 Datenschutz</h2>
            <p>
              Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer{' '}
              <a href="#/datenschutz" className="text-primary underline">Datenschutzerklärung</a>.
              Diese ist Bestandteil dieser AGB.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">§ 11 Schlussbestimmungen</h2>
            <p>
              (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
              UN-Kaufrechts (CISG).
            </p>
            <p className="mt-2">
              (2) Ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang
              mit diesem Vertrag ist — soweit gesetzlich zulässig — der Sitz des Anbieters.
            </p>
            <p className="mt-2">
              (3) Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein
              oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt
              (salvatorische Klausel).
            </p>
            <p className="mt-2">
              (4) Änderungen dieser AGB werden dem Nutzer per E-Mail oder durch Hinweis auf der
              Plattform mitgeteilt. Sie gelten als genehmigt, sofern der Nutzer nicht innerhalb
              von 4 Wochen nach Bekanntgabe widerspricht.
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
